const memberDetailsReportTypes = {
	/** ***************** FETCH MEMBER DETAILS REPORT START *********************** */
	FETCH_MEMBER_DETAILS_REPORT_START: 'fetch_member_details_report_start',
	FETCH_MEMBER_DETAILS_REPORT_SUCCESS: 'fetch_member_details_report_success',
	FETCH_MEMBER_DETAILS_REPORT_FAILURE: 'fetch_member_details_report_failure',
	FETCH_MEMBER_DETAILS_REPORT_RESPONSE_RESET_START: 'fetch_member_details_report_reset_start',
	FETCH_MEMBER_DETAILS_REPORT_RESPONSE_CHANGED: 'fetch_member_details_report_response_changed',
	/** ***************** FETCH MEMBER DETAILS REPORT END *********************** */
};

export default memberDetailsReportTypes;
